// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Logged in users'"></sub-header>

<form name="\$ctrl.form">

    <div class="filters">
      <div class="labelled-field labelled-field--long">
        <label for="filter-branch" class="add-on">Branch</label>
        <multiselect-null-wrapper
            items="\$ctrl.branches"
            ng-model="\$ctrl.selectedBranchIds"
            id="filter-branch"
            label-property="'name'"
            value-property="'id'"
            ng-if="\$ctrl.branches"
            ng-required="true"></multiselect-null-wrapper>
      </div>
      <div class="labelled-field labelled-field--long">
        <label for="filter-branch" class="add-on">Roles</label>
        <multiselect-null-wrapper
            items="\$ctrl.roles"
            ng-model="\$ctrl.selectedRoleIds"
            id="filter-roles"
            label-property="'name'"
            value-property="'id'"
            ng-if="\$ctrl.roles"
            ng-required="true"></multiselect-null-wrapper>
      </div>
      <div class="labelled-field labelled-field--long" ng-if="\$ctrl.isAgencyBankingEnabled">
        <label for="filter-branch" class="add-on">Agents only</label>
        <select
            ng-model="\$ctrl.agentOnly"
            ng-change="\$ctrl.filterAgentRoles()"
            boolean-options
            required>
        </select>
      </div>

      <button
          ng-click="\$ctrl.viewLoggedInUsers()"
          type="button"
          ng-disabled="!\$ctrl.form.\$valid"
          class="btn btn-primary">
        View
      </button>
    </div>

    <div class="table-content">
      <table class="table" ng-table="\$ctrl.tableConfig">
        <thead>
        <th>Logged in</th>
        <th>Branch</th>
        <th>User full name</th>
        <th>Username</th>
        <th>User role</th>
        <th>CMC</th>
        <th>Public IP</th>
        <th>Login date</th>
        <th>Login time</th>
        </thead>
        <tbody>
        <tr ng-repeat="item in \$data">
          <td>&nbsp;<i ng-class="{'logged-in-icon icon-ok-sign' : item.loggedIn, 'logged-out-icon icon-minus-sign' : !item.loggedIn}"></i>
          </td>
          <td>{{item.branchName}}</td>
          <td>{{item.userFullName}}</td>
          <td>{{item.username}}</td>
          <td>{{item.userRole | prettyEnum}}</td>
          <td>{{item.cmc}}</td>
          <td>{{item.publicIp}}</td>
          <td>{{item.loginTime | prettyDate}}</td>
          <td>{{item.loginTime | prettyTime}}</td>
        </tr>
        </tbody>
      </table>
    </div>
</form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/users/logged-in/logged-in-users.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;